import "./MfaBreakdown.css";
import { Loading } from '../../../common';

/**
 * Format method name
 * Example: authenticator_push → Authenticator Push
 */
const formatMethod = (method = "") => {
  return method
    .replace(/_/g, " ")
    .replace(/([A-Z])/g, " $1")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
};

/**
 * Get strength class
 */
const getStrengthClass = (strength = "") => {
  const s = strength.toLowerCase();
  if (s.includes("strong")) return "strong";
  if (s.includes("medium")) return "medium";
  if (s.includes("phishing resistant")) return "strong";
  if (s.includes("unknown")) return "medium";
  return "weak";
};

const MfaBreakdown = ({ data = [], loading = false, onMfaRowClick }) => {
  if (loading) {
    return (
      <div className="mfa-breakdown-card">
        <div className="mfa-breakdown-header">
          <h3 className="mfa-breakdown-title">
            MFA Method Distribution
          </h3>
        </div>
        <div className="mfa-empty">
          <Loading text="Loading MFA distribution…" />
        </div>
      </div>
    );
  }

  if (!data || data.length === 0) {
    return (
      <div className="mfa-breakdown-card">
        <div className="mfa-breakdown-header">
          <h3 className="mfa-breakdown-title">
            MFA Method Distribution
          </h3>
        </div>
        <div className="mfa-empty">
          No MFA distribution data available
        </div>
      </div>
    );
  }

  const handleRowClick = (item) => {
    onMfaRowClick?.(item);
  };

  return (
    <div className="mfa-breakdown-card">
      {/* Header */}
      <div className="mfa-breakdown-header">
        <h3 className="mfa-breakdown-title">
          MFA Method Distribution
        </h3>
      </div>

      {/* Table */}
      <div className="mfa-breakdown-table-wrapper">
        <table className="mfa-breakdown-table">
          <thead>
            <tr>
              <th>Method</th>
              <th>Users</th>
              <th>Percentage</th>
              <th>Strength</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, idx) => (
              <tr
                key={idx}
                className="mfa-row"
                onClick={() => handleRowClick(item.method)}
                role="button"
                tabIndex={0}
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleRowClick(item.method);
                  }
                }}
              >
                {/* Method */}
                <td>
                  <span className="mfa-method">
                    {formatMethod(item.method)}
                  </span>
                </td>

                {/* Users */}
                <td>
                  <span className="mfa-users">
                    {item.count}
                  </span>
                </td>

                {/* Percentage */}
                <td>
                  <div className="mfa-percentage-wrapper">
                    <div className="mfa-bar-track">
                      <div
                        className={`mfa-bar-fill mfa-bar-${getStrengthClass(
                          item.strength
                        )}`}
                        style={{
                          width: `${item.percentage}%`,
                        }}
                      />
                    </div>

                    <span className="mfa-percentage-text">
                      {item.percentage}%
                    </span>
                  </div>
                </td>

                {/* Strength */}
                <td>
                  <span
                    className={`mfa-strength-badge mfa-strength-${getStrengthClass(
                      item.strength
                    )}`}
                  >
                    {item.strength}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MfaBreakdown;